export const GetLatestNotifications = "/Notification/GetLatestNotifications";

export const NotificationReadAll = "/Notification/NotificationReadAll";

export const NotificationRead = "/Notification/NotificationRead";

export const GetNotificationList = ({ pageNumber, pageSize }) =>
  `/Notification/GetNotificationList?PageNumber=${pageNumber}&PageSize=${pageSize}`;
